__turbopack_context__.v({
  "buttons": "form-module__8K-bGW__buttons",
  "fieldset": "form-module__8K-bGW__fieldset",
  "form": "form-module__8K-bGW__form",
  "formRow": "form-module__8K-bGW__formRow",
  "note": "form-module__8K-bGW__note",
  "separator": "form-module__8K-bGW__separator",
});
